var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.425,
    height: 23.308,
    viewBox: "0 0 23.425 23.308",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_212",
    "data-name": "Trac\\xE9 212",
    d: "M12.05,10A2.06,2.06,0,0,0,10,12.039V31.269a2.06,2.06,0,0,0,2.05,2.039H31.376a2.06,2.06,0,0,0,2.05-2.039V15.536a.872.872,0,0,0-.256-.619l-4.685-4.662A.881.881,0,0,0,27.862,10Zm0,1.748h2.343v7.284a.876.876,0,0,0,.878.874H26.983a.876.876,0,0,0,.878-.874v-6.92L31.668,15.9V31.269a.274.274,0,0,1-.293.291H12.05a.274.274,0,0,1-.293-.291V12.039A.274.274,0,0,1,12.05,11.748Zm4.1,0H26.1v6.41H16.149Zm5.563,10.2a3.788,3.788,0,1,0,3.807,3.788A3.811,3.811,0,0,0,21.713,21.945Zm0,1.748a2.039,2.039,0,1,1-2.05,2.039A2.031,2.031,0,0,1,21.713,23.693Z",
    transform: "translate(-10 -10)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/save-icon.6a3435fd60d14418084a70a1c7defaf4.svg";
export { ForwardRef as ReactComponent };